// Talen van het bord (golf 3, 0033_talen; verzoek oprichter #16 "Talen: Turks, Engels, Arabisch,
// Duits, Frans"; antwoord: "dit moet een optie zijn bij de onboarding, de default moet zijn, een taal
// per gezin"). Eén register voor de webapp, de kiosk, de API en de e-mails. Puur en kiosk-veilig:
// geen andere catalogi hier (die laadt de kiosk los per taal, zie pack.ts).
//
// De code is wat de database bewaart (household.locale, member.locale, device.locale). Arabisch
// heeft bewust geen regio: `ar-SA` kiest in Intl standaard de islamitische kalender, wij willen de
// gewone (gregoriaanse) agenda; de Intl-tag zet de kalender en de cijfers daarom altijd expliciet.
export const LOCALES = ['nl-NL', 'en-GB', 'tr-TR', 'ar', 'de-DE', 'fr-FR'];
export const DEFAULT_LOCALE = 'nl-NL';
/** Cijfers: gewone (Latijnse) of Arabisch-Indische (٠١٢٣). Standaard Latijns. */
export const DIGITS = ['latn', 'arab'];
export const LOCALE_INFO = {
    'nl-NL': {
        code: 'nl-NL',
        lang: 'nl',
        nativeName: 'Nederlands',
        dir: 'ltr',
        speech: 'nl-NL',
        intl: 'nl-NL',
    },
    'en-GB': {
        code: 'en-GB',
        lang: 'en',
        nativeName: 'English',
        dir: 'ltr',
        speech: 'en-GB',
        intl: 'en-GB',
    },
    'tr-TR': {
        code: 'tr-TR',
        lang: 'tr',
        nativeName: 'Türkçe',
        dir: 'ltr',
        speech: 'tr-TR',
        intl: 'tr-TR',
    },
    ar: {
        code: 'ar',
        lang: 'ar',
        nativeName: 'العربية',
        dir: 'rtl',
        speech: 'ar-SA',
        intl: 'ar',
    },
    'de-DE': {
        code: 'de-DE',
        lang: 'de',
        nativeName: 'Deutsch',
        dir: 'ltr',
        speech: 'de-DE',
        intl: 'de-DE',
    },
    'fr-FR': {
        code: 'fr-FR',
        lang: 'fr',
        nativeName: 'Français',
        dir: 'ltr',
        speech: 'fr-FR',
        intl: 'fr-FR',
    },
};
export function isLocaleCode(value) {
    return typeof value === 'string' && LOCALES.indexOf(value) >= 0;
}
/**
 * Elke invoer (`nl`, `tr-TR`, `ar-EG`, `EN-us`, null) naar een ondersteunde code; onbekend → nl.
 * Eerst exact, dan op taal (de eerste twee letters).
 */
export function normalizeLocale(value) {
    if (!value)
        return DEFAULT_LOCALE;
    if (isLocaleCode(value))
        return value;
    const lang = value.slice(0, 2).toLowerCase();
    for (const code of LOCALES)
        if (LOCALE_INFO[code].lang === lang)
            return code;
    return DEFAULT_LOCALE;
}
export function localeInfo(value) {
    return LOCALE_INFO[normalizeLocale(value)];
}
export function isRtl(value) {
    return localeInfo(value).dir === 'rtl';
}
export function isDigits(value) {
    return value === 'latn' || value === 'arab';
}
/**
 * Welke taal geldt? Per tablet of per gezinslid boven het gezin, maar alleen als de module Talen
 * aan staat (uitzetten wist de keuzes niet; ze tellen dan alleen niet). null = "Zoals het gezin".
 */
export function effectiveLocale(household, override, overridesOn = true) {
    if (overridesOn && override && isLocaleCode(override))
        return override;
    return normalizeLocale(household);
}
/**
 * Cijfers tellen alleen in het Arabisch (de keuze staat alleen daar). Elke andere taal: Latijns.
 */
export function effectiveDigits(locale, digits) {
    return normalizeLocale(locale) === 'ar' && digits === 'arab' ? 'arab' : 'latn';
}
/**
 * Intl-tag met expliciete kalender en cijfers: `ar-u-ca-gregory-nu-latn`. Safari 12 kent beide
 * extensies (JavaScriptCore/ICU); de gregoriaanse kalender voorkomt dat een Arabische tablet ineens
 * Hijri-datums toont, en `nu` houdt tijden leesbaar tenzij het gezin ٠١٢ koos.
 */
export function intlTag(locale, digits = 'latn') {
    return `${localeInfo(locale).intl}-u-ca-gregory-nu-${digits}`;
}
const ARABIC_INDIC = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
/** Zet 0-9 om naar Arabisch-Indische cijfers (alleen bij `arab`). */
export function localizeDigits(text, digits) {
    if (digits !== 'arab')
        return text;
    return text.replace(/[0-9]/g, (d) => { var _a; return (_a = ARABIC_INDIC[d.charCodeAt(0) - 48]) !== null && _a !== void 0 ? _a : d; });
}
// ---- Weergave-instelling van deze app (webapp of kiosk: één actieve taal tegelijk) ----------
// De server rendert voor veel gezinnen tegelijk en zet dit nooit; daar blijft het Latijns.
let displayDigits = 'latn';
/** Cijfers voor getallen in t()/interpolate() en formatClock() (webapp en kiosk). */
export function setDisplayDigits(digits) {
    displayDigits = digits;
}
export function getDisplayDigits() {
    return displayDigits;
}
//# sourceMappingURL=locales.js.map